export const validateUrl = (url: string): boolean => {
  const regExp = /^(http|https):\/\/[\s\S]+/g;

  return regExp.test(url);
};
